export const place = { id: "publicos", path: "/publicos" } as const;
